export const considerOptions = () => [
	['Desconto na unidade (-)', 'unity-discount'],
	['Pagamento na proposta (+)', 'payment-proposal']
]

export const typeOptions = () => [
	['Financiamento', 'financing_config'],
	['FGTS', 'fgts_config'],
	['Subsídio', 'allowance_config']
]

export const showOptions = () => [
	['Preenchido', 'filled'],
	['Sempre', 'always']
]

export const makeOptions = (options) => {
	const list = []
	options.forEach((op, index) => {
		list.push({
			id: index,
			label: op[0],
			value: op[1]
		})
	})
	return list
}

export const makeMonetaryOptions = (listTypes) => {
	const list = []
	listTypes.forEach((type) => {
		if (type.fields.length == 0) return

		type.fields.forEach((field) => {
			list.push({
				id: field.id,
				label: field.name,
				type: type.name,
				value: field.id
			})
		})
	})
	return list
}

export const makeTablePayment = (tableLines, monetaryFields, tableName) => {
	const linesList = []
	tableLines.forEach((line, index) => {
		linesList.push(
			makeTableLine(
				index,
				[line.field, monetaryFields],
				line.consider,
				line.type,
				line.show,
				tableName
			)
		)
	})
	return linesList
}

export const makeTableLine = (id, [field, fieldData], consider, type, show, tableName) => {
	const f = (options, key) => options.find((opt) => opt[1] === key)[0]
	return {
		id: id,
		field: [...fieldData].find((opt) => opt.id === parseInt(field)).label,
		consider: f([...considerOptions()], consider),
		type: f([...typeOptions()], type),
		show: f([...showOptions()], show),
		table: tableName
	}
}

export const makeColumnsTable = () => [
	{ title: 'Campo Personalizado' },
	{ title: 'Considerar como' },
	{ title: 'Tipo' },
	{ title: 'Exibir quando' },
	{ title: '', size: '50' }
]
